import { RefObject } from 'react';
import { toast } from 'react-toastify';

import { FormHandles } from '@unform/core';
import axios from 'axios';
import yup from 'src/libs/yup';
import { store } from 'src/store';
import { AuthActions } from 'src/store/ducks/auth';

interface APIValidationError {
  rule: string;
  field: string;
  message: string;
}

export const showErrorToast = (message: string): void => {
  toast(message, { type: 'error' });
};

export const showFormErrors = (
  errors: Record<string, string>,
  formRef: RefObject<FormHandles>,
): void => {
  showErrorToast('Por favor, verifique os dados informados.');

  formRef?.current?.setErrors(errors);
};

export const handleApiValidationErrors = (
  errors: APIValidationError[],
  yupSchema: yup.BaseSchema,
  formRef: RefObject<FormHandles>,
): void => {
  const formErrors: Record<string, string> = {};

  errors.forEach((error) => {
    let label = '';
    try {
      label = yup.reach(yupSchema, error.field).describe().label || '';
    } catch (error) {}

    formErrors[error.field] = error.message.replace(error.field, label);
  });

  showFormErrors(formErrors, formRef);
};

export const handleErrors = (
  error: unknown,
  defaultMessage = 'Ocorreu algum erro.',
  yupSchema?: yup.BaseSchema,
  formRef?: RefObject<FormHandles>,
): void => {
  if (!error || !axios.isAxiosError(error) || !error.response) {
    return showErrorToast(defaultMessage);
  }

  const { response } = error;

  switch (response.status) {
    case 400:
    case 404:
      return showErrorToast(response.data.custom_error || defaultMessage);
    case 401:
      if (response.data.logout) {
        store.dispatch(AuthActions.authLogout());
      }

      return showErrorToast(response.data.custom_error || defaultMessage);
    case 422:
      if (!yupSchema || !formRef) {
        return showErrorToast(defaultMessage);
      } else {
        return handleApiValidationErrors(
          response.data.errors,
          yupSchema,
          formRef,
        );
      }
    default:
      if (response.data.custom_error) {
        return showErrorToast(response.data.custom_error);
      } else if (Array.isArray(response.data.errors)) {
        const errorMessage = response.data.errors
          .map((error: any) => error.message)
          .join(' ');

        return showErrorToast(errorMessage);
      } else {
        return showErrorToast(defaultMessage);
      }
  }
};
